module.exports = __webpack_public_path__ + "static/media/google_play_badge_en_color_40.d1ac129b.svg";